import { Box } from '@mui/system'


function Handsake() {
  return (
   <Box >
  <img
    src="/img1/hand-shaking.gif" // ✅ Use .gif file
    alt="Handshake Animation"
    style={{
      width: "100%",
      height: "auto",
    }}
  />
</Box>

  )
}

export default Handsake